<template>
  <div class="button-floating-component">
    <a v-if="videos.length === 1" :href="videos[0].video_url" target="_blank" class="buttonfloat to-top">
      <vs-button icon="help" size="large" class="cursor-pointer"></vs-button>
    </a>

    <div class="buttonfloat to-top" v-else-if="videos.length > 1">
      <vs-dropdown class="cursor-pointer">
        <vs-button
            size="large"
            icon="help"
            class="cursor-pointer"
        >
        </vs-button>
        <vs-dropdown-menu class="button-dropdown">
          <vs-dropdown-item
              :key="index"
              v-for="(video, index) in videos"
              @click.prevent="redirectTo(video.video_url)"
              @touchstart.prevent="redirectTo(video.video_url)"
          >
            {{ video.name }}
            <hr />
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>

    <InternalChatContact
        :upListUsers="openListUsers"
        @downListUsers="closeListUsers()"
      />

    <div v-if="validate && !twoFactorActivated" class="chat-internal bg-primary select-none"  :class="{ 'button-internal-chat-ios': isIos, 'button-internal-chat-android': isAndroid}">
      <vs-drop-down v-model="activeItem" class="w-full">
        <div class="flex w-full"  @click.stop="toggleListUsers">
          <vs-avatar :badge="chatNotification" class="icon-navbar bg-primary cursor-none"/>
          <span class="text-white align-self-center" :class="{ 'mr-12': !isAndroid && !isIos, 'mr-2': isAndroid || isIos }">Chat Interno</span>
          <feather-icon class="text-white cursor-pointer " icon="ChevronUpIcon" @click.stop="toggleListUsers"/>
        </div>
      </vs-drop-down>
    </div>
  </div>
</template>

<script>

import { getCurrentRoute } from '@/utils'
import tutorialVideosApi from '@/http/requests/tutorialVideos'

import VsDropdown from "../vs-dropdown/dropdown.vue";
import VsDropdownMenu from "../vs-dropdown/dropdown-menu.vue";
import VsDropdownItem from "../vs-dropdown/dropdown-item.vue";
import InternalChatContact from "../../layouts/components/internal-chat-message/InternalChatContact.vue";

export default {
  name:'ButtonFloating',
  data() {
    return {
      videos: [],
      validate: false,
      activeItem: false,
      openListUsers: false,
      twoFactorActivated: false
    }
  },
  components: {
    VsDropdown,
    VsDropdownMenu,
    VsDropdownItem,
    InternalChatContact,
  },
  methods: {
    async getTrainingVideo() {
      const route = getCurrentRoute();
      this.videos = (await tutorialVideosApi.fetch({ route })).data.data.tutorialVideos
    },
    redirectTo(url) {
      window.open(url, '_blank');
    },
    toggleListUsers(){
      this.openListUsers = true
    },
    closeListUsers(){
      this.openListUsers = false
      this.$store.dispatch('internalChatMessages/resetInternalChatMessage');
    },
    transparentValidate() {
      let auth = this.$store.state.auth.bearer;
      let authValidate = this.currentRoute;
      const validAuth = [
        '/login',
        '/forgot',
        '/forgot/*',
        '/page-error-404',
        '/page-error-500',
        '/reset-password',
        '/not-authorized',
        '/pages/error-404',
        '/pages/error-500',
        '/page-coming-son',
        '/forgot-password',
        '/pages/comingsoon',
        '/page-not-authorized',
        '/forgot-new-password',
        '/pages/tenant-invalid',
        '/page-error-tenant-invalid',
      ];

      this.validate = auth !== null && auth !== 'Successfully disconnected' && !validAuth.includes(authValidate);
    },
  },
  computed: {
    isIos() {
      return window.innerWidth <= 430 && window.innerHeight <= 932;
    },
    isAndroid() {
      return window.innerWidth <= 393 && window.innerHeight <= 873;
    },
    chatNotification(){
      const internalUsers = this.$store.state.user.internalUsers;
      let internalUsersWithValue = [];

      internalUsers.forEach((user) => {
        if (user.unseenMsg > 0) {
          internalUsersWithValue.push(user)
        }
      })
      
      return internalUsersWithValue.length
    },
  },
  watch:{
    '$store.state.AppActiveUser': {
    handler(newVal, oldVal) {
        if (newVal.twofactor_activity && !newVal.is_two_factor_validated) {
          this.twoFactorActivated = true;
        } else {
          this.twoFactorActivated = false;
        }
      },
      deep: true
    }
  },
  async mounted() {
    await this.getTrainingVideo()
    this.transparentValidate()
    this.$router.afterEach(() => {
      this.getTrainingVideo()
    })
  }
}

</script>

<style lang="scss">
.buttonfloat {
  position: fixed;
  right: 0;

  &.to-top {
    top: 45vh!important;
    z-index: 1000!important;
  }
}

.align-self-center{
  align-self: center;
}

.buttonfloat .vs-button.large i.vs-button--icon {
  font-size: 2rem;
}

.button-dropdown {
  min-width: 20rem;
  font-size: 1.2rem;

  a {
    color: #626262!important;
  }
}

.chat-internal, .ios-condicion {
  right: 0;
  bottom: 0;
  width: 16rem;
  height: 3.3rem;
  display: flex;
  position: fixed;
  margin-bottom: 0;
  align-items: center;
  margin-right: 10rem;
  z-index: 1000!important;
  border-radius: 2rem 2rem 0 0;
}

.button-internal-chat-ios{
  margin-right: 19px; 
  width: 130px; 
  height: 36px;  
  font-size: 12px;
}

.button-internal-chat-android{
  margin-right: 19px; 
  width: 130px; 
  height: 36px;  
  font-size: 12px;
}
.span-internal-chat-android{
  text-align: center;
}


</style>
